import { render, staticRenderFns } from "./CRRegenerate.vue?vue&type=template&id=7cf0bc15&scoped=true"
import script from "./CRRegenerate.vue?vue&type=script&setup=true&lang=js"
export * from "./CRRegenerate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRRegenerate.vue?vue&type=style&index=0&id=7cf0bc15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf0bc15",
  null
  
)

export default component.exports